import { __decorate, __metadata } from 'tslib';
import * as i5$1 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { RendererFactory2, Injectable, Inject, forwardRef, Directive, Component, ViewEncapsulation, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i3 from '@angular/router';
import { Router } from '@angular/router';
import { AvailableGdsThemes, themeCheck } from '@upr-gds-web/components';
import { AutoSubscription } from '@upr-web-primer/app-utils';
import * as i6 from '@upr-web-primer/ftc';
import { FtcService, FtcModule } from '@upr-web-primer/ftc';
import * as i4 from '@upr-web-primer/gds-common-utility';
import { GdsCommonUtilityService } from '@upr-web-primer/gds-common-utility';
import * as i1 from '@upr-web-primer/ms-guests';
import { MsGuestsService } from '@upr-web-primer/ms-guests';
import * as i5 from '@upr-web-primer/notification';
import { NotificationService } from '@upr-web-primer/notification';
import * as i2 from '@upr-web-primer/spinner';
import { SpinnerService } from '@upr-web-primer/spinner';
import { get, isEmpty, isEqual, trimEnd } from 'lodash-es';
import moment from 'moment';
import { Subscription, BehaviorSubject, fromEvent } from 'rxjs';
import * as i1$1 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormControl, FormGroup, FormArray, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i2$1 from '@upr-web-primer/form-fields';
import { FormControlService, FormFieldsModule } from '@upr-web-primer/form-fields';
import { GdsInputHelperDirective, gdsRequiredValidator, gdsMaxLengthValidator, gdsMinLengthValidator, gdsPatternValidator, NumberCharPattern, gdsOnlyOneRequiredValidator } from '@upr-web-primer/gds-input-helper';
import * as i4$1 from '@upr-web-primer/page-labels';
import { PageLabelsResolver } from '@upr-web-primer/page-labels';
function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_gds_input_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "gds-input", 16);
  }
  if (rf & 2) {
    const formElement_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formControlName", formElement_r1.name)("theme", ctx_r1.theme)("data", formElement_r1.data)("type", formElement_r1.type)("id", formElement_r1.name)("value", ctx_r1.sampleForm == null ? null : ctx_r1.sampleForm.controls[formElement_r1.name] == null ? null : ctx_r1.sampleForm.controls[formElement_r1.name].value)("errors", ctx_r1.sampleForm == null ? null : ctx_r1.sampleForm.controls[formElement_r1.name] == null ? null : ctx_r1.sampleForm.controls[formElement_r1.name].errors == null ? null : ctx_r1.sampleForm.controls[formElement_r1.name].errors.message)("hideSpinner", true);
  }
}
function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_gds_dropdown_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "gds-dropdown", 17);
  }
  if (rf & 2) {
    let tmp_10_0;
    const formElement_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formControlName", formElement_r1.name)("theme", ctx_r1.theme)("data", formElement_r1.data)("id", formElement_r1.name)("isNative", (tmp_10_0 = formElement_r1.isNative) !== null && tmp_10_0 !== undefined ? tmp_10_0 : false)("value", ctx_r1.sampleForm == null ? null : ctx_r1.sampleForm.controls[formElement_r1.name] == null ? null : ctx_r1.sampleForm.controls[formElement_r1.name].value)("errorMessage", ctx_r1.sampleForm == null ? null : ctx_r1.sampleForm.controls[formElement_r1.name] == null ? null : ctx_r1.sampleForm.controls[formElement_r1.name].errors == null ? null : ctx_r1.sampleForm.controls[formElement_r1.name].errors.message);
  }
}
function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_gds_input_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "gds-input", 18);
    i0.ɵɵlistener("valueChange", function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_gds_input_4_Template_gds_input_valueChange_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const formElement_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.fieldValueChange($event.detail, formElement_r1.name));
    })("blurChange", function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_gds_input_4_Template_gds_input_blurChange_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const formElement_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.fieldBlurChange(formElement_r1.name));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const formElement_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("theme", ctx_r1.theme)("data", formElement_r1.data)("type", formElement_r1.type)("id", formElement_r1.name)("value", formElement_r1.data.value)("errors", ctx_r1.sampleForm == null ? null : ctx_r1.sampleForm.controls[formElement_r1.name] == null ? null : ctx_r1.sampleForm.controls[formElement_r1.name].errors == null ? null : ctx_r1.sampleForm.controls[formElement_r1.name].errors.message);
  }
}
function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_name_field_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "upr-gds-name-field", 19);
    i0.ɵɵlistener("formReady", function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_name_field_5_Template_upr_gds_name_field_formReady_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const formElement_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.addFormControl(formElement_r1.name, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const formElement_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", formElement_r1.name)("formData", formElement_r1.data)("theme", ctx_r1.theme);
  }
}
function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_name_field_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "upr-gds-name-field", 19);
    i0.ɵɵlistener("formReady", function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_name_field_6_Template_upr_gds_name_field_formReady_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const formElement_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.addFormControl(formElement_r1.name, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const formElement_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", formElement_r1.name)("formData", formElement_r1.data)("theme", ctx_r1.theme);
  }
}
function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_name_field_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "upr-gds-name-field", 19);
    i0.ɵɵlistener("formReady", function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_name_field_7_Template_upr_gds_name_field_formReady_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const formElement_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.addFormControl(formElement_r1.name, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const formElement_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", formElement_r1.name)("formData", formElement_r1.data)("theme", ctx_r1.theme);
  }
}
function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_phone_field_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "upr-gds-phone-field", 20);
    i0.ɵɵlistener("formReady", function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_phone_field_8_Template_upr_gds_phone_field_formReady_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const formElement_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.addFormControl(formElement_r1.name, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const formElement_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", formElement_r1.name)("formData", formElement_r1.data)("countryName", ctx_r1.selectedCountry)("theme", ctx_r1.theme);
  }
}
function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_email_field_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "upr-gds-email-field", 19);
    i0.ɵɵlistener("formReady", function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_email_field_9_Template_upr_gds_email_field_formReady_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const formElement_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.addFormControl(formElement_r1.name, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const formElement_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", formElement_r1.name)("formData", formElement_r1.data)("theme", ctx_r1.theme);
  }
}
function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_dob_field_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "upr-gds-dob-field", 19);
    i0.ɵɵlistener("formReady", function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_dob_field_10_Template_upr_gds_dob_field_formReady_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const formElement_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.addFormControl(formElement_r1.name, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const formElement_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", formElement_r1.name)("formData", formElement_r1.data)("theme", ctx_r1.theme);
  }
}
function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_address_field_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "upr-gds-address-field", 21);
    i0.ɵɵlistener("formReady", function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_address_field_11_Template_upr_gds_address_field_formReady_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const formElement_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.addFormControl(formElement_r1.name, $event));
    })("countryChange", function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_address_field_11_Template_upr_gds_address_field_countryChange_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const formElement_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onCountryChange($event, formElement_r1.data.action));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const formElement_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", formElement_r1.name)("country", ctx_r1.selectedCountry)("state", ctx_r1.selectedState)("formData", formElement_r1.data)("isZipCodeMandiory", ctx_r1.isZipCodeManditory)("useNativeStateDropdown", true)("theme", ctx_r1.theme);
  }
}
function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 22);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHTML", ctx_r1.countryLabel, i0.ɵɵsanitizeHtml);
  }
}
function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_ng_container_13_upr_gds_address_field_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "upr-gds-address-field", 24);
    i0.ɵɵlistener("formReady", function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_ng_container_13_upr_gds_address_field_1_Template_upr_gds_address_field_formReady_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const formElement_r1 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.addFormControl(formElement_r1.name, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const formElement_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", formElement_r1.name)("country", ctx_r1.selectedCountry)("state", ctx_r1.selectedState)("formData", formElement_r1.data)("isZipCodeMandiory", ctx_r1.isZipCodeManditory)("useNativeStateDropdown", true)("theme", ctx_r1.theme);
  }
}
function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_ng_container_13_gds_spacer_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "gds-spacer", 25);
  }
}
function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GdsInputFormComponent_div_2_ng_container_3_ng_container_1_ng_container_13_upr_gds_address_field_1_Template, 1, 7, "upr-gds-address-field", 23)(2, GdsInputFormComponent_div_2_ng_container_3_ng_container_1_ng_container_13_gds_spacer_2_Template, 1, 0, "gds-spacer", 15);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isUsCountry);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isUsCountry);
  }
}
function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_ng_container_14_upr_gds_address_field_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "upr-gds-address-field", 24);
    i0.ɵɵlistener("formReady", function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_ng_container_14_upr_gds_address_field_1_Template_upr_gds_address_field_formReady_0_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const formElement_r1 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.addFormControl(formElement_r1.name, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const formElement_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", formElement_r1.name)("country", ctx_r1.selectedCountry)("state", ctx_r1.selectedState)("formData", formElement_r1.data)("isZipCodeMandiory", formElement_r1.required)("useNativeStateDropdown", true)("theme", ctx_r1.theme);
  }
}
function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_ng_container_14_gds_spacer_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "gds-spacer", 25);
  }
}
function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_ng_container_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GdsInputFormComponent_div_2_ng_container_3_ng_container_1_ng_container_14_upr_gds_address_field_1_Template, 1, 7, "upr-gds-address-field", 23)(2, GdsInputFormComponent_div_2_ng_container_3_ng_container_1_ng_container_14_gds_spacer_2_Template, 1, 0, "gds-spacer", 15);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isUsCountry);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isUsCountry);
  }
}
function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_gds_buttons_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "gds-buttons", 26);
    i0.ɵɵlistener("buttonClicked", function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_gds_buttons_15_Template_gds_buttons_buttonClicked_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const formElement_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.gdsButtonClicked(formElement_r1.data.action));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const formElement_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("theme", ctx_r1.theme)("data", formElement_r1.data)("id", formElement_r1.name);
  }
}
function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_gds_spacer_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "gds-spacer", 25);
  }
}
function GdsInputFormComponent_div_2_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0)(1, 5);
    i0.ɵɵtemplate(2, GdsInputFormComponent_div_2_ng_container_3_ng_container_1_gds_input_2_Template, 1, 8, "gds-input", 6)(3, GdsInputFormComponent_div_2_ng_container_3_ng_container_1_gds_dropdown_3_Template, 1, 7, "gds-dropdown", 7)(4, GdsInputFormComponent_div_2_ng_container_3_ng_container_1_gds_input_4_Template, 1, 6, "gds-input", 8)(5, GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_name_field_5_Template, 1, 3, "upr-gds-name-field", 9)(6, GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_name_field_6_Template, 1, 3, "upr-gds-name-field", 9)(7, GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_name_field_7_Template, 1, 3, "upr-gds-name-field", 9)(8, GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_phone_field_8_Template, 1, 4, "upr-gds-phone-field", 10)(9, GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_email_field_9_Template, 1, 3, "upr-gds-email-field", 9)(10, GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_dob_field_10_Template, 1, 3, "upr-gds-dob-field", 9)(11, GdsInputFormComponent_div_2_ng_container_3_ng_container_1_upr_gds_address_field_11_Template, 1, 7, "upr-gds-address-field", 11)(12, GdsInputFormComponent_div_2_ng_container_3_ng_container_1_div_12_Template, 1, 1, "div", 12)(13, GdsInputFormComponent_div_2_ng_container_3_ng_container_1_ng_container_13_Template, 3, 2, "ng-container", 13)(14, GdsInputFormComponent_div_2_ng_container_3_ng_container_1_ng_container_14_Template, 3, 2, "ng-container", 13)(15, GdsInputFormComponent_div_2_ng_container_3_ng_container_1_gds_buttons_15_Template, 1, 3, "gds-buttons", 14)(16, GdsInputFormComponent_div_2_ng_container_3_ng_container_1_gds_spacer_16_Template, 1, 0, "gds-spacer", 15);
    i0.ɵɵelementContainerEnd()();
  }
  if (rf & 2) {
    const formElement_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", formElement_r1.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.gdsInputTypes.includes(formElement_r1.type) ? formElement_r1.type : "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "select");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "radio");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "firstName");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "lastName");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "suffix");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "phoneNumber");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "email");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "dateOfBirth");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "country");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "country");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "state");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "zip");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "button");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", formElement_r1.type !== "state" && formElement_r1.type !== "zip");
  }
}
function GdsInputFormComponent_div_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GdsInputFormComponent_div_2_ng_container_3_ng_container_1_Template, 17, 16, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.formElements);
  }
}
function GdsInputFormComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 2);
    i0.ɵɵelement(2, "div", 3);
    i0.ɵɵtemplate(3, GdsInputFormComponent_div_2_ng_container_3_Template, 2, 1, "ng-container", 1);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.sampleForm);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.removeForm);
  }
}
const GroupValidatorKey = 'OnlyOneRequired';
const CONFIRMATION_STATUS = Object.freeze({
  SUCCESS: 'success',
  FAILURE: 'failure',
  LOCATED: 'located',
  LOCATED_REMAINING_PAYMENTS: 'located-remaining-payments',
  ALREADY_CANCELLED: 'already-canceled',
  NO_RECORDS_FOUND: 'no-records-found',
  CANCELED: 'canceled'
});
const FORM_ACTION = Object.freeze({
  EXIT_CANCELLATION: 'exit_cancellation',
  FIND_ANNUAL_PASS: 'find_annual_pass',
  CANCEL_AUTO_RENEW: 'cancel_auto_renew',
  DELETE_FIELD_ON_SUBMIT: 'delete_field_on_submit',
  REMOVE_ZIPCODE_ON_NON_US_COUNTRY: 'remove-zipcode-on-non-US-country',
  UDX_FORM_SUBMIT: 'udx_form_submit',
  EMAIL_OFFERS_SUFFIX: '_EMAIL_OFFERS',
  UNSUBSCRIBE_SUFFIX: '_UNSUBSCRIBE',
  SEND_CANCELLATION_EMAIL: 'send_cancellation_email'
});
let GdsInputFormService = class GdsInputFormService {
  constructor(document, defaultValues, msGuestService, spinner, router, commonUtilService, notification, renderer, ftcService) {
    this.document = document;
    this.defaultValues = defaultValues;
    this.msGuestService = msGuestService;
    this.spinner = spinner;
    this.router = router;
    this.commonUtilService = commonUtilService;
    this.notification = notification;
    this.renderer = renderer;
    this.ftcService = ftcService;
    this.subscriptions = new Subscription();
    this.eventSubmit = new BehaviorSubject(0);
    this.eventSubmit$ = this.eventSubmit.asObservable();
    this.removeForm = new BehaviorSubject(false);
    this.removeForm$ = this.removeForm.asObservable();
    this.resetForm = new BehaviorSubject(false);
    this.resetForm$ = this.resetForm.asObservable();
    this.theme = AvailableGdsThemes[0];
    this.calloutFormLoaded = fromEvent(this.document, 'gdsCalloutFormContainerLoaded');
    this.renderer2 = this.renderer.createRenderer(null, null);
  }
  getServiceDetails(data) {
    const confirmationFields = get(data, 'confirmation');
    if (confirmationFields) {
      this.setStatusComponents(confirmationFields);
      this.failureMessage = confirmationFields.failure_message;
      this.successMessage = confirmationFields.success_message;
      const redirectUrl = confirmationFields.redirection_url;
      this.redirectUrl = redirectUrl ? this.commonUtilService.resolveLinkUrl(redirectUrl) : redirectUrl;
      this.navigateAfterSuccess = ['true', true].includes(confirmationFields.navigate_after_submit);
    }
    this.sourceId = data.source_id;
  }
  renderInputForm(inputFormComponent) {
    // Store source ID
    let gdsCalloutFormContainer = document.querySelector('gds-callout-form-container');
    this.theme = themeCheck(get(inputFormComponent, 'theme', 'gds-default'));
    this.getServiceDetails(inputFormComponent.data);
    if (gdsCalloutFormContainer?.data) {
      this.setInputFormToCallout(inputFormComponent, gdsCalloutFormContainer);
    }
    if (!gdsCalloutFormContainer) {
      this.subscriptions.add(this.calloutFormLoaded.subscribe(() => {
        gdsCalloutFormContainer = document.querySelector('gds-callout-form-container');
        this.setInputFormToCallout(inputFormComponent, gdsCalloutFormContainer);
      }));
    }
  }
  setFormContainerData(formData) {
    const topComponentArticleDetail = {
      selector: 'gds-article-detail',
      data: {
        ...formData?.formdetail,
        hideGrid: true
      },
      meta: {
        type: 'left'
      }
    };
    const bottomComponentArticleDetail = {
      selector: 'gds-article-detail',
      data: {
        ...formData?.bottomformdetail,
        hideGrid: true
      },
      meta: {
        type: 'left'
      }
    };
    this.initialFormData = {
      border: [true, 'true'].includes(formData?.border),
      topComponents: [topComponentArticleDetail],
      bottomComponents: [bottomComponentArticleDetail]
    };
    this.resources = get(formData, 'resources.Resource', []).reduce((acc, {
      Key,
      Value
    }) => {
      acc[Key] = Value;
      return acc;
    }, {});
    formData.data = this.initialFormData;
    return structuredClone(this.initialFormData);
  }
  setCalloutFormData(calloutFormComponent, backgroundColor) {
    const data = calloutFormComponent.data;
    calloutFormComponent.data = {
      backgroundColor: backgroundColor ?? '',
      components_right: data.components_right,
      components_left: [{
        selector: 'gds-image-info-section',
        data: {
          components: [{
            selector: 'gds-avatar',
            data: {
              image: data.avatarimage
            }
          }, {
            selector: 'gds-spacer',
            meta: {
              classes: 'spacer-80'
            }
          }, {
            selector: 'gds-heading',
            data: {
              heading: get(data, 'callouttext.headline', '')
            },
            meta: {
              classes: 'heading-4'
            }
          }, {
            selector: 'gds-spacer',
            meta: {
              classes: 'spacer-70'
            }
          }, ...this.setListItemData(data), {
            selector: 'gds-body',
            data: {
              description: get(data, 'callouttext.description', '')
            },
            meta: {
              classes: 'body-5'
            }
          }]
        }
      }]
    };
  }
  setInputFormToCallout(inputFormComponent, gdsCalloutFormContainer) {
    const inputFormContainerData = this.setFormContainerData({
      ...inputFormComponent.data
    });
    gdsCalloutFormContainer.data = {
      ...gdsCalloutFormContainer.data,
      components_right: [{
        selector: 'gds-form-container',
        data: inputFormContainerData
      }]
    };
  }
  getHeaders() {
    const httpHeaders = this.msGuestService.helper.getNoCacheHeaders();
    const instanceId = this.msGuestService.helper.getInstanceId();
    if (!!instanceId) {
      httpHeaders['x-instance-id'] = instanceId;
    }
    if (!!this.sourceId) {
      httpHeaders['x-source-id'] = this.sourceId;
    }
    return httpHeaders;
  }
  setListItemData(calloutFormData) {
    const listItems = get(calloutFormData, 'callouttext.listItem', []);
    return listItems.flatMap(listItem => {
      return [{
        selector: 'gds-feature-icon-2',
        data: {
          svgOptions: {
            iconName: listItem.icon,
            width: 16.67,
            height: 16.67
          },
          iconLabel: listItem.heading,
          iconLabelStyle: 'heading-11'
        }
      }, {
        selector: 'gds-spacer',
        meta: {
          classes: 'spacer-70'
        }
      }];
    });
  }
  setStatusComponents(confirmation) {
    const statusComponents = get(confirmation, 'statusComponent', []);
    this.statusComponents = Array.isArray(statusComponents) ? statusComponents : [statusComponents];
  }
  getSubmitComponents(status) {
    const newStatusComponents = this.statusComponents.find(sc => sc.status === status);
    if (!newStatusComponents) return [];
    let containerElements = get(newStatusComponents, 'container.elements', []);
    containerElements = Array.isArray(containerElements) ? containerElements : [containerElements];
    return containerElements.map(element => {
      const ev = get(element, 'componentTemplate.MetadataFields.attributes.EmbeddedValues', []);
      const meta = ev.reduce((acc, v) => {
        const key = get(v, 'key.Values[0]', '');
        const value = get(v, 'value.Values[0]', '');
        if (key && value !== 'value') acc[key] = value;
        return acc;
      }, {});
      const component = {
        selector: get(element, 'componentTemplate.MetadataFields.name.Values[0]'),
        data: get(element, 'component'),
        theme: this.theme,
        contrast: false,
        meta
      };
      this.setComponentSpecificProps(component);
      return component;
    });
  }
  createOrderSummary(remainingPayments, data) {
    const spacer8px = {
      selector: 'gds-spacer',
      meta: {
        classes: 'spacer-30'
      }
    };
    const spacer24px = {
      selector: 'gds-spacer',
      meta: {
        classes: 'spacer-70'
      }
    };
    const hr = {
      selector: 'hr'
    };
    const OrderNumber = !isEmpty(data.order_confirmation_number) ? [{
      selector: 'gds-summary-row-2',
      data: {
        label: get(this.resources, 'orderConfirmationNumber', ''),
        price: `${data.order_confirmation_number}`
      }
    }, spacer8px] : [];
    const linkedPasses = [{
      selector: 'gds-summary-row-1',
      data: {
        label: get(this.resources, 'annualPassCount', ''),
        price: `${data.linked_passes.length}`
      }
    }];
    data.linked_passes.forEach(pass => {
      linkedPasses.push(spacer8px);
      linkedPasses.push({
        selector: 'gds-block-data',
        data: {
          heading: `${get(pass, 'first_name', '')} ${get(pass, 'last_name', '')}`,
          description: `${get(pass, 'pass_description', '')}<br>ID: [${get(pass, 'pass_id', '')}]`
        }
      });
    });
    const remainingPaymentsFields = remainingPayments ? [{
      selector: 'gds-summary-row-2',
      data: {
        label: get(this.resources, 'remainingInstallments', ''),
        price: `${get(data, 'remaining_payments', '')}`,
        option: 'option-4'
      }
    }, spacer8px, {
      selector: 'gds-summary-row-2',
      data: {
        label: get(this.resources, 'nextBillingDate', ''),
        price: data.next_payment_date ? `${moment(data.next_payment_date).format('MM/DD/YYYY')}` : '',
        option: 'option-4'
      }
    }, spacer8px, {
      selector: 'gds-summary-row-2',
      data: {
        label: get(this.resources, 'randomText', '')
      }
    }] : [];
    return [hr, ...OrderNumber, {
      selector: 'gds-summary-row-2',
      data: {
        label: get(this.resources, 'emailAddress', ''),
        price: `${get(data, 'email', '')}`
      }
    }, spacer8px, {
      selector: 'gds-summary-row-2',
      data: {
        label: get(this.resources, 'name', ''),
        price: `${data.first_name} ${data.last_name}`
      }
    }, spacer8px, ...remainingPaymentsFields, hr, ...linkedPasses, spacer24px];
  }
  setComponentSpecificProps(component) {
    switch (component.selector) {
      case 'gds-content-callout':
        component.meta['full-width'] = true;
        break;
      case 'gds-article-detail':
        component.data = {
          ...component.data,
          hideGrid: true
        };
        break;
      case 'gds-form-container':
        component.selector = 'gds-buttons';
        component.meta.onButtonClicked = e => this.statusButtonClicked(e);
    }
  }
  statusButtonClicked(event) {
    const action = get(event, 'detail.data.action');
    if (action.toLowerCase() === FORM_ACTION.EXIT_CANCELLATION) {
      this.resetFormData(this.initialFormData);
      this.resetForm.next(true);
    } else if (action.toLowerCase() === FORM_ACTION.CANCEL_AUTO_RENEW) {
      this.spinner.show();
      this.cancelButtonClicked().then(response => {
        if (response.status === 200) {
          const submitComponents = this.getSubmitComponents(CONFIRMATION_STATUS.SUCCESS);
          this.renderSubmitComponents(submitComponents, true);
        } else {
          const failureComponents = this.getSubmitComponents(CONFIRMATION_STATUS.FAILURE);
          this.renderSubmitComponents(failureComponents, false);
        }
      }).catch(error => {
        console.log('error', error);
        const failureComponents = this.getSubmitComponents(CONFIRMATION_STATUS.FAILURE);
        this.renderSubmitComponents(failureComponents, false);
      }).finally(() => {
        this.spinner.hide();
      });
    }
  }
  cancelButtonClicked() {
    return this.ftcService.cancelSubscriptionContract(this.requestPayload, this.defaultValues.RESORT_AREA_CODE).then(res => {
      return res;
    });
  }
  removeComponents(displayComponents) {
    displayComponents.forEach(component => {
      const index = this.initialFormData.topComponents.findIndex(x => x.selector === component.selector);
      if (index > -1) {
        this.initialFormData.topComponents.splice(index, 1);
      }
    });
  }
  renderSubmitComponents(displayComponents, removeForm) {
    const {
      topDisplayComponents,
      buttonComponents
    } = displayComponents.reduce((acc, component) => {
      (component.selector === 'gds-buttons' ? acc.buttonComponents : acc.topDisplayComponents).push(component);
      return acc;
    }, {
      buttonComponents: [],
      topDisplayComponents: []
    });
    const formContainer = this.document.querySelector('gds-form-container');
    let topComponents = get(formContainer, 'data.topComponents', []);
    let bottomComponents = get(formContainer, 'data.bottomComponents', []);
    if (removeForm) {
      topComponents = topDisplayComponents;
      bottomComponents = buttonComponents;
      this.removeForm.next(true);
    } else {
      const topArticleDetailIndex = topComponents.findIndex(c => c.selector === 'gds-article-detail');
      const filteredNewComponents = topDisplayComponents.filter(c => {
        return !topComponents.some(topC => topC.selector === c.selector && isEqual(topC, c));
      });
      topArticleDetailIndex !== -1 ? topComponents.splice(topArticleDetailIndex + 1, 0, ...filteredNewComponents) : topComponents.push(...filteredNewComponents);
    }
    const bottomComponentsInline = bottomComponents.filter(bc => {
      return bc.selector === 'gds-buttons';
    }).length > 1;
    this.resetFormData({
      ...formContainer.data,
      topComponents,
      bottomComponents,
      bottomComponentsInline
    });
    this.scrollToForm(topComponents.some(c => c.selector === 'gds-content-callout'));
  }
  resetFormData(data) {
    const formContainer = this.document.querySelector('gds-form-container');
    formContainer.data = data;
  }
  scrollToForm(scrollToContentCallout = false) {
    if (scrollToContentCallout) {
      let contentCallout = this.document.querySelector('gds-content-callout');
      if (contentCallout) {
        this.performCenterScroll(contentCallout);
        return;
      }
      const calloutHandler = () => {
        contentCallout = this.document.querySelector('gds-content-callout');
        if (contentCallout) {
          window.removeEventListener('gdsComponentLoaded', calloutHandler);
          requestAnimationFrame(() => {
            this.performCenterScroll(contentCallout);
          });
        }
      };
      window.addEventListener('gdsComponentLoaded', calloutHandler);
      return;
    }
    let formContainer = this.document.querySelector('gds-form-container');
    if (formContainer) {
      this.performFormScroll(formContainer);
      return;
    }
    const formHandler = () => {
      formContainer = this.document.querySelector('gds-form-container');
      if (formContainer) {
        window.removeEventListener('gdsComponentLoaded', formHandler);
        requestAnimationFrame(() => {
          this.performFormScroll(formContainer);
        });
      }
    };
    window.addEventListener('gdsComponentLoaded', formHandler);
  }
  performCenterScroll(element) {
    const rect = element.getBoundingClientRect();
    const scrollTop = window.pageYOffset;
    const targetScrollTop = rect.top + scrollTop - window.innerHeight / 2 + rect.height / 2;
    window.scrollTo({
      top: targetScrollTop,
      behavior: 'smooth'
    });
  }
  performFormScroll(element) {
    const elementTop = element.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: elementTop - window.innerHeight / 4,
      behavior: 'smooth'
    });
  }
  _getSubscriptionStatus(data) {
    if (data?.status === 'canceled' || data?.status === 'active' && !data?.auto_renewal) {
      return CONFIRMATION_STATUS.ALREADY_CANCELLED;
    } else {
      //active
      return data?.remaining_payments > 0 ? CONFIRMATION_STATUS.LOCATED_REMAINING_PAYMENTS : CONFIRMATION_STATUS.LOCATED;
    }
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  submitEmailOptInOut(data) {
    this.spinner.show();
    this.msGuestService.account.service.emailOptInOut(data, this.getHeaders()).then(() => {
      this.spinner.hide();
      const successComponents = this.getSubmitComponents(CONFIRMATION_STATUS.SUCCESS);
      if (this.navigateAfterSuccess) {
        this.router.navigate([this.redirectUrl]);
      } else if (successComponents.length) {
        this.renderSubmitComponents(successComponents, false);
      } else {
        this.notification.show(this.successMessage, 'success');
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
      this.eventSubmit.next(true);
    }).catch(error => {
      this.spinner.hide();
      console.log(error);
      const failureComponents = this.getSubmitComponents(CONFIRMATION_STATUS.FAILURE);
      if (failureComponents.length) {
        this.renderSubmitComponents(failureComponents, false);
      } else {
        this.notification.show(this.failureMessage, 'error');
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    });
  }
  findAnnualPass(data) {
    let status;
    const id = data.order_confirmation_number ? {
      order_confirmation_number: data.order_confirmation_number
    } : {
      pass_id: data.pass_id
    };
    this.requestPayload = {
      email: data.email_address,
      first_name: data.first_name,
      last_name: data.last_name,
      last_four: data.credit_card,
      id
    };
    this.spinner.show();
    return this.ftcService.findSubscriptionContract(this.requestPayload, this.defaultValues.RESORT_AREA_CODE).then(res => {
      res = {
        ...res,
        ...{
          first_name: this.requestPayload.first_name,
          last_name: this.requestPayload.last_name,
          order_confirmation_number: res.order_confirmation_number || this.requestPayload.id.order_confirmation_number
        }
      };
      status = this._getSubscriptionStatus(res);
      if (res) {
        const failureComponents = this.getSubmitComponents(CONFIRMATION_STATUS.FAILURE);
        this.removeComponents(failureComponents);
      }
      this.spinner.hide();
      if (this.navigateAfterSuccess) {
        this.router.navigate([this.redirectUrl]);
      } else {
        const submitComponents = this.getSubmitComponents(status);
        if (status === CONFIRMATION_STATUS.LOCATED) {
          this.renderSubmitComponents([...submitComponents, ...this.createOrderSummary(false, res)], true);
        } else if (status === CONFIRMATION_STATUS.LOCATED_REMAINING_PAYMENTS) {
          this.renderSubmitComponents([...this.getSubmitComponents(CONFIRMATION_STATUS.LOCATED), ...this.createOrderSummary(true, res)], true);
        } else if (status === CONFIRMATION_STATUS.NO_RECORDS_FOUND) {
          this.renderSubmitComponents(submitComponents, false);
        } else if (status === CONFIRMATION_STATUS.ALREADY_CANCELLED) {
          this.renderSubmitComponents(submitComponents, true);
        } else if (submitComponents.length) {
          this.renderSubmitComponents(submitComponents, false);
        } else {
          this.notification.show(this.successMessage, 'success');
        }
      }
    }).catch(error => {
      console.log('error', error);
      const failureComponents = this.getSubmitComponents(CONFIRMATION_STATUS.FAILURE);
      this.renderSubmitComponents(failureComponents, false);
    }).finally(() => {
      this.spinner.hide();
    });
  }
  sendCancellationEmail(data) {
    const id = data.order_confirmation_number ? {
      order_confirmation_number: data.order_confirmation_number
    } : {
      pass_id: data.pass_id
    };
    this.requestPayload = {
      email: data.email_address,
      first_name: data.first_name,
      last_name: data.last_name,
      id
    };
    this.spinner.show();
    return this.ftcService.sendCancellationEmail(this.requestPayload, this.defaultValues.RESORT_AREA_CODE).then(() => {
      this.spinner.hide();
      const submitComponents = this.getSubmitComponents(CONFIRMATION_STATUS.SUCCESS);
      this.renderSubmitComponents(submitComponents, true);
    }).catch(error => {
      console.log('error', error);
      const failureComponents = this.getSubmitComponents(CONFIRMATION_STATUS.FAILURE);
      this.renderSubmitComponents(failureComponents, false);
    }).finally(() => {
      this.spinner.hide();
    });
  }
  static {
    this.ɵfac = function GdsInputFormService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsInputFormService)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject('DefaultValues'), i0.ɵɵinject(i1.MsGuestsService), i0.ɵɵinject(i2.SpinnerService), i0.ɵɵinject(i3.Router), i0.ɵɵinject(i4.GdsCommonUtilityService), i0.ɵɵinject(i5.NotificationService), i0.ɵɵinject(i0.RendererFactory2), i0.ɵɵinject(i6.FtcService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsInputFormService,
      factory: GdsInputFormService.ɵfac,
      providedIn: 'root'
    });
  }
};
GdsInputFormService = __decorate([AutoSubscription(), __metadata("design:paramtypes", [Object, Object, MsGuestsService, SpinnerService, Router, GdsCommonUtilityService, NotificationService, RendererFactory2, FtcService])], GdsInputFormService);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsInputFormService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['DefaultValues']
    }]
  }, {
    type: i1.MsGuestsService
  }, {
    type: i2.SpinnerService
  }, {
    type: i3.Router
  }, {
    type: i4.GdsCommonUtilityService
  }, {
    type: i5.NotificationService
  }, {
    type: i0.RendererFactory2
  }, {
    type: i6.FtcService
  }], null);
})();
const gdsInputTypes = ['text', 'textarea', 'checkbox', 'date', 'password', 'number', 'date', 'time', 'month', 'week', 'tel', 'range', 'reset', 'url', 'search', 'datetime', 'color', 'file'];
const gdsButtonTypes = ['primary', 'secondary', 'tertiary', 'tertiary-small'];
const specialGdsInputTypes = ['radio', 'select'];
const gdsFormFieldTypes = ['firstName', 'lastName', 'suffix', 'phoneNumber', 'dateOfBirth', 'email', 'country', 'state', 'zip'];
const gdsFormElementTypes = ['maxCharacterCount', 'characterCountThreshold', 'cols', 'rows'];
const isOptInOutTypes = type => {
  return type?.includes(FORM_ACTION.EMAIL_OFFERS_SUFFIX);
};
const isFieldToDelete = type => {
  return type === FORM_ACTION.DELETE_FIELD_ON_SUBMIT;
};
const createFormData = (formData, checkBoxFields, optInOutMap, fieldsToDelete) => {
  const opt_in_out = [];
  const result = {};
  let optOutExists = false;
  Object.keys(formData).forEach(field => {
    if (!fieldsToDelete.includes(field)) {
      result[field] = formData[field];
      // Change checkbox field string value to boolean
      if (checkBoxFields.includes(field)) {
        result[field] = result[field] === 'checked';
      }
      /* Create opt_in_out array field from form data
          "opt_in_out": [{
              "type": "UOR_EMAIL_OFFERS",
              "opt_in": true|false
          }]
      */
      if (optInOutMap[field]) {
        const isUnsubscribe = optInOutMap[field].includes(FORM_ACTION.UNSUBSCRIBE_SUFFIX);
        if (isUnsubscribe && !optOutExists) {
          optOutExists = true;
        }
        opt_in_out.push({
          type: isUnsubscribe ? optInOutMap[field].replace(FORM_ACTION.UNSUBSCRIBE_SUFFIX, '') : optInOutMap[field],
          opt_in: isUnsubscribe && result[field] ? false : result[field]
        });
        delete result[field];
      }
      // To pass service validation, email offers fields has to be false when there's a opt out.
      if (optOutExists) {
        if (result.email_offers_promos) {
          result.email_offers_promos = false;
        }
        if (result.email_offers_promos_ush) {
          result.email_offers_promos_ush = false;
        }
      }
    }
  });
  return {
    ...result,
    opt_in_out
  };
};
class GdsInputFormCvaDirective extends GdsInputHelperDirective {
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵGdsInputFormCvaDirective_BaseFactory;
      return function GdsInputFormCvaDirective_Factory(__ngFactoryType__) {
        return (ɵGdsInputFormCvaDirective_BaseFactory || (ɵGdsInputFormCvaDirective_BaseFactory = i0.ɵɵgetInheritedFactory(GdsInputFormCvaDirective)))(__ngFactoryType__ || GdsInputFormCvaDirective);
      };
    })();
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: GdsInputFormCvaDirective,
      selectors: [["gds-input"], ["gds-dropdown"]],
      standalone: false,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => GdsInputFormCvaDirective),
        multi: true
      }]), i0.ɵɵInheritDefinitionFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsInputFormCvaDirective, [{
    type: Directive,
    args: [{
      // eslint-disable-next-line @angular-eslint/directive-selector
      selector: 'gds-input, gds-dropdown',
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => GdsInputFormCvaDirective),
        multi: true
      }],
      standalone: false
    }]
  }], null, null);
})();
let GdsInputFormComponent = class GdsInputFormComponent {
  constructor(fb, document, formControlService, inputFormService, pageLabelsResolver) {
    this.fb = fb;
    this.document = document;
    this.formControlService = formControlService;
    this.inputFormService = inputFormService;
    this.pageLabelsResolver = pageLabelsResolver;
    this.gdsInputTypes = gdsInputTypes;
    this.theme = AvailableGdsThemes[0];
    this.removeForm = false;
    this.selectedCountry = '';
    this.isZipCodeManditory = true;
    this.formDataReady = false;
    this.disableInvalidSubmitButton = false;
    this.radioGroups = [];
    this.isUsCountry = true;
    this.countryLabel = '';
    this.checkBoxFields = [];
    this.fieldsToDelete = [];
    this.formOptInOutMap = {};
    this.groupValidatorMap = new Map();
    this.subscriptions.add(this.inputFormService.eventSubmit$.subscribe(event => {
      if (event) {
        this.clearFormValues();
      }
    }));
    this.subscriptions.add(this.inputFormService.removeForm$.subscribe(removeForm => {
      if (removeForm) {
        this.removeForm = true;
      }
    }));
    this.subscriptions.add(this.inputFormService.resetForm$.subscribe(resetForm => {
      if (resetForm) {
        this.removeForm = false;
        this.clearFormValues();
      }
    }));
  }
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @typescript-eslint/no-empty-function
  ngOnInit() {
    // For AutoSubscription
  }
  initForm(formData, pageLabels) {
    this.sampleForm = this.fb.group({});
    this.checkBoxFields = [];
    this.fieldsToDelete = [];
    this.formOptInOutMap = {};
    this.initFormData = formData;
    if (!pageLabels) {
      this.pageLabelsResolver.get().then(pageLabels => {
        this.pageLabels = pageLabels;
        this.setFormElements(formData);
      });
    } else {
      this.pageLabels = pageLabels;
      this.setFormElements(formData);
    }
  }
  setFormElements(formData) {
    this.formControlService.pageLabels = this.pageLabels;
    this.theme = themeCheck(get(formData, 'theme', 'gds-default'));
    this.formControls = this.formControlService;
    this.nameControls = this.formControls.nameControls;
    this.suffixControl = this.formControls.suffixControl;
    this.addressControls = this.formControls.addressControls;
    this.phoneControl = this.formControls.phoneControl;
    this.emailControl = this.formControls.emailControl;
    this.dateOfBirthControl = this.formControls.dateOfBirthControl;
    const fields = [...get(formData, 'data.sections.fields', [])];
    if (!fields?.length) {
      return;
    }
    this.formElements = fields.flatMap(formElement => {
      const {
        field
      } = formElement;
      field.name = field.name?.trim();
      field.required = [true, 'true'].includes(field.required);
      if (field.type === 'checkbox') {
        this.checkBoxFields.push(field.name);
      }
      if (isFieldToDelete(field.action)) {
        this.fieldsToDelete.push(field.name);
      }
      if (isOptInOutTypes(field.action)) {
        this.formOptInOutMap[field.name] = field.action;
      }
      this.checkForGroupValidation(field);
      if (gdsInputTypes.includes(field.type) && field.name) {
        this.setFormControlElement(field);
        return this.setInputData(field);
      } else if (field.type === 'select') {
        field.requiredSRText = field.required ? get(this.formControlService?.pageLabels, 'requiredSRText') : '';
        this.setFormControlElement(field);
        return this.setDropdownData(field);
      } else if (field.type === 'radio') {
        return [...this.setRadioData(field)];
      } else if (gdsFormFieldTypes.includes(field.type)) {
        return this.setFormFieldData(field);
      } else if (gdsButtonTypes.includes(field.type)) {
        return this.setButtonData(field);
      }
      return field;
    });
    this.setGroupValidation();
    this.formDataReady = true;
  }
  setFormFieldData(formElement) {
    let controls;
    switch (formElement.type) {
      case 'firstName':
        controls = this.nameControls[0];
        break;
      case 'lastName':
        controls = this.nameControls[1];
        break;
      case 'suffix':
        controls = this.suffixControl;
        break;
      case 'phoneNumber':
        controls = this.phoneControl;
        break;
      case 'email':
        controls = this.emailControl;
        break;
      case 'dateOfBirth':
        controls = this.dateOfBirthControl;
        break;
      case 'country':
        controls = this.addressControls[0];
        break;
      case 'state':
        controls = this.addressControls[5];
        break;
      case 'zip':
        controls = this.addressControls[3];
        break;
      default:
        controls = {};
        break;
    }
    const {
      label = '',
      supportingText = '',
      tooltip = '',
      placeholder = '',
      value = ''
    } = formElement;
    return {
      ...controls,
      ...formElement,
      data: {
        ...controls,
        ...formElement,
        label,
        supportingText,
        tooltip,
        placeholder,
        value
      }
    };
  }
  setInputData(formElement) {
    for (const property in formElement) {
      const propertyValue = formElement[property];
      if (gdsFormElementTypes.includes(property) && propertyValue && Array.isArray(propertyValue) && propertyValue[0]) {
        formElement[property] = Number(propertyValue[0]);
      }
    }
    return {
      ...formElement,
      data: {
        ...formElement,
        primaryLabel: formElement.label ?? '',
        supportingText: formElement.supportingText ?? '',
        placeholder: formElement.placeholder ?? ''
      }
    };
  }
  setDropdownData(formElement) {
    return {
      ...formElement,
      data: {
        formField: {
          primaryLabel: formElement.label,
          supportingText: formElement.supportingText,
          tooltip: formElement.tooltip
        },
        options: formElement.options.map(option => {
          return {
            label: option,
            value: option
          };
        }),
        placeholder: formElement.placeholder,
        required: formElement.required,
        requiredSRText: formElement.requiredSRText
      }
    };
  }
  setRadioData(formElement) {
    this.setFormControlElement(formElement);
    return formElement.options.map(option => {
      return {
        ...formElement,
        data: {
          primaryLabel: option,
          value: option,
          name: formElement.name,
          default: formElement.value && formElement.value === option
        }
      };
    });
  }
  setButtonData(formElement) {
    return {
      type: 'button',
      data: formElement
    };
  }
  getGdsInputType(formElement) {
    return gdsInputTypes.includes(formElement.type) || formElement.type === 'radio' ? formElement.type : '';
  }
  getGdsInputValue(formElement) {
    return formElement.type === 'radio' ? formElement.data.value : this.sampleForm?.controls[formElement.name]?.value;
  }
  getValidatorsArray(formElement) {
    return Array.isArray(formElement.validations) ? formElement.validations : [formElement.validations];
  }
  getValidators(formElement) {
    const validations = this.getValidatorsArray(formElement);
    const validators = [];
    if (formElement.required) {
      validators.push(gdsRequiredValidator(this.pageLabels.ER26));
      formElement.label = trimEnd(formElement.label, '*').trim();
      formElement.label = `${formElement.label}*`;
    }
    if (gdsInputTypes.includes(formElement.type) && validations.length) {
      validations.forEach(validation => {
        const fieldValidator = get(validation, 'fieldValidator', false);
        const condition = get(validation, 'condition', false);
        if (!fieldValidator || validation.fieldValidator === '-') return;
        if (fieldValidator === 'MaxLength' && condition) {
          const maxLength = validation.condition;
          validators.push(gdsMaxLengthValidator(Number(maxLength), this.pageLabels.maxLengthError));
        }
        if (fieldValidator === 'MinLength' && condition) {
          const minLength = validation.condition;
          validators.push(gdsMinLengthValidator(Number(minLength), this.pageLabels.minLengthError));
        }
        if (fieldValidator === 'NoSpecialCharacters') {
          validators.push(gdsPatternValidator(NumberCharPattern.NO_SPECIAL_CHARS, this.pageLabels.ER12));
        }
      });
    }
    return validators;
  }
  setFormControlElement(formElement) {
    this.addFormControl(formElement.name.trim(),
    // Revert
    new FormControl(formElement.value ?? '', this.getValidators(formElement)));
  }
  /**
   * Add form control
   * @param {string} name
   * @param {FormControl} formControl
   * @param {string} formGroupName
   */
  addFormControl(name, formControl, formGroupName) {
    const formGroup = this.getFormGroup(formGroupName);
    if (formGroup?.get(name)) {
      formGroup.removeControl(name);
    }
    formGroup?.addControl(name, formControl);
  }
  /**
   * Removes one or more form controls from the specified form group.
   *
   * @param {string | string[]} controlNames - The name or an array of names of the form controls to be removed.
   * @returns {void}
   */
  removeFormControls(controlNames) {
    const names = Array.isArray(controlNames) ? controlNames : [controlNames];
    names.forEach(name => {
      if (this.sampleForm.get(name)) {
        this.sampleForm.removeControl(name);
      }
    });
  }
  /**
   * Get form group
   * @param {string} name
   * @returns {FormGroup}
   */
  getFormGroup(name) {
    return name ? this.sampleForm.get(name) : this.sampleForm;
  }
  /**
   * Checks for validation rules with multiple fields impacted
   * @param {GdsFormElement} formElement
   */
  checkForGroupValidation(formElement) {
    this.getValidatorsArray(formElement).forEach(validation => {
      const fieldValidator = get(validation, 'fieldValidator', '');
      const message = get(validation, 'condition', '');
      if (fieldValidator.includes(GroupValidatorKey)) {
        const existingEntry = this.groupValidatorMap.get(fieldValidator) || {
          fields: [],
          message
        };
        const uniqueFields = new Set([...existingEntry.fields, formElement.name]);
        this.groupValidatorMap.set(fieldValidator, {
          fields: Array.from(uniqueFields),
          message: existingEntry.message
        });
      }
    });
  }
  /**
   * Sets groupValidatorMap with matching validators
   * @param {GdsFormElement} formElement
   */
  setGroupValidation() {
    if (this.groupValidatorMap.size > 0) {
      this.groupValidatorMap.forEach(({
        fields,
        message
      }) => {
        fields.forEach(fieldName => {
          const control = this.sampleForm.get(fieldName);
          if (!control) return;
          control.addValidators(gdsOnlyOneRequiredValidator(fields, message));
        });
      });
    }
  }
  getFormControl(name) {
    return this.sampleForm.controls[name];
  }
  onCountryChange(country, action) {
    if (action === FORM_ACTION.REMOVE_ZIPCODE_ON_NON_US_COUNTRY) {
      if (country === 'US' && this.selectedCountry !== 'US') {
        if (this.selectedCountry) {
          this.countryLabel = 'State and zip code sections added.';
        }
        this.isUsCountry = true;
      } else if (country !== 'US' && this.selectedCountry === 'US') {
        this.countryLabel = 'State and zip code sections removed.';
        this.isUsCountry = false;
        const zipCode = this.formElements.find(f => f.type === 'zip')?.name;
        const stateCode = this.formElements.find(f => f.type === 'state')?.name;
        this.removeFormControls([zipCode, stateCode]);
      }
    }
    this.selectedCountry = country;
  }
  /**
   * Validates all form fields in the given form group, marks them as touched,
   * and focuses on the first invalid control, if any.
   *
   * @param {FormGroup} formGroup - The form group to be validated.
   * @returns {void}
   */
  validateAllFormFields(formGroup) {
    const firstInvalidControl = this.recursivelyMarkControlsAsTouched(formGroup);
    if (firstInvalidControl) {
      this.focusOnControl(firstInvalidControl);
    }
  }
  /**
   * Recursively marks all controls within the provided form group as touched
   * and returns the first invalid control encountered, if any.
   *
   * @param {FormGroup} formGroup - The form group to be processed.
   * @returns {FormControl | null} The first invalid control, if found.
   */
  recursivelyMarkControlsAsTouched(formGroup) {
    let firstInvalidControl = null;
    const parentControls = formGroup.controls;
    for (const formElement of this.formElements) {
      const {
        name
      } = formElement;
      if (parentControls.hasOwnProperty(name)) {
        const control = parentControls[name];
        if (control instanceof FormControl) {
          this.validateFormControl(control);
          if (control.invalid && !firstInvalidControl) {
            firstInvalidControl = control;
          }
        } else if (control instanceof FormGroup) {
          const childInvalidControl = this.recursivelyMarkControlsAsTouched(control);
          if (childInvalidControl && !firstInvalidControl) {
            firstInvalidControl = childInvalidControl;
          }
        }
      }
    }
    return firstInvalidControl;
  }
  recursivelyMarkControlsAsUntouched(form) {
    Object.values(form.controls).forEach(control => {
      if (control instanceof FormGroup || control instanceof FormArray) {
        this.recursivelyMarkControlsAsUntouched(control);
      }
      control.markAsUntouched();
    });
  }
  /**
   * Marks the given form control as touched and sets its value.
   *
   * @param {FormControl} control - The form control to be validated.
   * @returns {void}
   */
  validateFormControl(control) {
    control?.markAsTouched({
      onlySelf: true
    });
    control?.setValue(control?.value);
  }
  /**
   * Focuses on the provided form control by scrolling it into view with smooth animation.
   *
   * @param {FormControl} control - The form control to be focused.
   * @returns {void}
   */
  focusOnControl(control) {
    const parent = control?.parent;
    if (parent) {
      const controlName = Object.keys(parent.controls).find(name => parent.get(name) === control);
      const inputElement = this.document.querySelector(`#${controlName} input, #${controlName} select, #${controlName} textarea, #${controlName} gds-dropdown-control`);
      if (inputElement) {
        inputElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  }
  fieldValueChange(value, controlName) {
    this.getFormControl(controlName).setValue(value);
  }
  fieldBlurChange(controlName) {
    this.getFormControl(controlName).markAsTouched();
  }
  gdsButtonClicked(action) {
    if (!this.isFormValid()) return;
    if (action.toLowerCase() === FORM_ACTION.UDX_FORM_SUBMIT) {
      const formData = createFormData(this.sampleForm.value, this.checkBoxFields, this.formOptInOutMap, this.fieldsToDelete);
      this.inputFormService.submitEmailOptInOut(formData);
    } else if (action.toLowerCase() === FORM_ACTION.FIND_ANNUAL_PASS) {
      this.inputFormService.findAnnualPass(this.sampleForm.value);
    } else if (action.toLowerCase() === FORM_ACTION.SEND_CANCELLATION_EMAIL) {
      this.inputFormService.sendCancellationEmail(this.sampleForm.value);
    }
  }
  isFormValid() {
    this.validateAllFormFields(this.sampleForm);
    return this.sampleForm.valid;
  }
  clearFormValues() {
    this.initForm(this.initFormData, this.pageLabels);
    this.recursivelyMarkControlsAsUntouched(this.sampleForm);
  }
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @typescript-eslint/no-empty-function
  ngOnDestroy() {
    // For AutoSubscription
  }
  static {
    this.ɵfac = function GdsInputFormComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsInputFormComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i2$1.FormControlService), i0.ɵɵdirectiveInject(GdsInputFormService), i0.ɵɵdirectiveInject(i4$1.PageLabelsResolver));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GdsInputFormComponent,
      selectors: [["upr-gds-input-form"]],
      standalone: false,
      decls: 3,
      vars: 1,
      consts: [["gdsInputFormElem", ""], [4, "ngIf"], ["slot", "gds-form", 3, "formGroup"], [1, "submit-components"], [4, "ngFor", "ngForOf"], [3, "ngSwitch"], [3, "formControlName", "theme", "data", "type", "id", "value", "errors", "hideSpinner", 4, "ngSwitchCase"], [3, "formControlName", "theme", "data", "id", "isNative", "value", "errorMessage", 4, "ngSwitchCase"], [3, "theme", "data", "type", "id", "value", "errors", "valueChange", "blurChange", 4, "ngSwitchCase"], [3, "id", "formData", "theme", "formReady", 4, "ngSwitchCase"], [3, "id", "formData", "countryName", "theme", "formReady", 4, "ngSwitchCase"], [3, "id", "country", "state", "formData", "isZipCodeMandiory", "useNativeStateDropdown", "theme", "formReady", "countryChange", 4, "ngSwitchCase"], ["role", "region", "aria-live", "polite", "class", "sr-only", 3, "innerHTML", 4, "ngSwitchCase"], [4, "ngSwitchCase"], [3, "theme", "data", "id", "buttonClicked", 4, "ngSwitchCase"], ["classes", "spacer-50", 4, "ngIf"], [3, "formControlName", "theme", "data", "type", "id", "value", "errors", "hideSpinner"], [3, "formControlName", "theme", "data", "id", "isNative", "value", "errorMessage"], [3, "valueChange", "blurChange", "theme", "data", "type", "id", "value", "errors"], [3, "formReady", "id", "formData", "theme"], [3, "formReady", "id", "formData", "countryName", "theme"], [3, "formReady", "countryChange", "id", "country", "state", "formData", "isZipCodeMandiory", "useNativeStateDropdown", "theme"], ["role", "region", "aria-live", "polite", 1, "sr-only", 3, "innerHTML"], [3, "id", "country", "state", "formData", "isZipCodeMandiory", "useNativeStateDropdown", "theme", "formReady", 4, "ngIf"], [3, "formReady", "id", "country", "state", "formData", "isZipCodeMandiory", "useNativeStateDropdown", "theme"], ["classes", "spacer-50"], [3, "buttonClicked", "theme", "data", "id"]],
      template: function GdsInputFormComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementContainerStart(0, null, 0);
          i0.ɵɵtemplate(2, GdsInputFormComponent_div_2_Template, 4, 2, "div", 1);
          i0.ɵɵelementContainerEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.formDataReady);
        }
      },
      dependencies: [i5$1.NgForOf, i5$1.NgIf, i5$1.NgSwitch, i5$1.NgSwitchCase, i2$1.GdsAddressFieldComponent, i2$1.GdsNameFieldComponent, i2$1.GdsPhoneFieldComponent, i2$1.GdsEmailFieldComponent, i2$1.GdsDobFieldComponent, i1$1.NgControlStatus, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i1$1.FormControlName, GdsInputFormCvaDirective],
      styles: [".sr-only{position:absolute;width:1px;height:1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;clip-path:inset(50%);border:0}\n"],
      encapsulation: 2
    });
  }
};
GdsInputFormComponent = __decorate([AutoSubscription(), __metadata("design:paramtypes", [FormBuilder, Document, FormControlService, GdsInputFormService, PageLabelsResolver])], GdsInputFormComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsInputFormComponent, [{
    type: Component,
    args: [{
      selector: 'upr-gds-input-form',
      standalone: false,
      encapsulation: ViewEncapsulation.None,
      template: "<ng-container #gdsInputFormElem>\r\n\t<div *ngIf=\"formDataReady\">\r\n\t\t<div slot=\"gds-form\" [formGroup]=\"sampleForm\">\r\n\t\t\t<div class=\"submit-components\"></div>\r\n\t\t\t<ng-container *ngIf=\"!removeForm\">\r\n\t\t\t\t<ng-container *ngFor=\"let formElement of formElements\">\r\n\t\t\t\t\t<ng-container [ngSwitch]=\"formElement.type\">\r\n\t\t\t\t\t\t<!-- Generic Input -->\r\n\t\t\t\t\t\t<gds-input\r\n\t\t\t\t\t\t\t*ngSwitchCase=\"\r\n\t\t\t\t\t\t\t\tgdsInputTypes.includes(formElement.type) ? formElement.type : ''\r\n\t\t\t\t\t\t\t\"\r\n\t\t\t\t\t\t\t[formControlName]=\"formElement.name\"\r\n\t\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t\t[data]=\"formElement.data\"\r\n\t\t\t\t\t\t\t[type]=\"formElement.type\"\r\n\t\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t\t[value]=\"sampleForm?.controls[formElement.name]?.value\"\r\n\t\t\t\t\t\t\t[errors]=\"sampleForm?.controls[formElement.name]?.errors?.message\"\r\n\t\t\t\t\t\t\t[hideSpinner]=\"true\"\r\n\t\t\t\t\t\t></gds-input>\r\n\r\n\t\t\t\t\t\t<!-- Generic Dropdown -->\r\n\t\t\t\t\t\t<gds-dropdown\r\n\t\t\t\t\t\t\t*ngSwitchCase=\"'select'\"\r\n\t\t\t\t\t\t\t[formControlName]=\"formElement.name\"\r\n\t\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t\t[data]=\"formElement.data\"\r\n\t\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t\t[isNative]=\"formElement.isNative ?? false\"\r\n\t\t\t\t\t\t\t[value]=\"sampleForm?.controls[formElement.name]?.value\"\r\n\t\t\t\t\t\t\t[errorMessage]=\"\r\n\t\t\t\t\t\t\t\tsampleForm?.controls[formElement.name]?.errors?.message\r\n\t\t\t\t\t\t\t\"\r\n\t\t\t\t\t\t></gds-dropdown>\r\n\r\n\t\t\t\t\t\t<!-- Radio -->\r\n\t\t\t\t\t\t<gds-input\r\n\t\t\t\t\t\t\t*ngSwitchCase=\"'radio'\"\r\n\t\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t\t[data]=\"formElement.data\"\r\n\t\t\t\t\t\t\t[type]=\"formElement.type\"\r\n\t\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t\t[value]=\"formElement.data.value\"\r\n\t\t\t\t\t\t\t[errors]=\"sampleForm?.controls[formElement.name]?.errors?.message\"\r\n\t\t\t\t\t\t\t(valueChange)=\"fieldValueChange($event.detail, formElement.name)\"\r\n\t\t\t\t\t\t\t(blurChange)=\"fieldBlurChange(formElement.name)\"\r\n\t\t\t\t\t\t></gds-input>\r\n\r\n\t\t\t\t\t\t<!-- First Name -->\r\n\t\t\t\t\t\t<upr-gds-name-field\r\n\t\t\t\t\t\t\t*ngSwitchCase=\"'firstName'\"\r\n\t\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t>\r\n\t\t\t\t\t\t</upr-gds-name-field>\r\n\r\n\t\t\t\t\t\t<!-- Last Name -->\r\n\t\t\t\t\t\t<upr-gds-name-field\r\n\t\t\t\t\t\t\t*ngSwitchCase=\"'lastName'\"\r\n\t\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t>\r\n\t\t\t\t\t\t</upr-gds-name-field>\r\n\r\n\t\t\t\t\t\t<!-- Suffix -->\r\n\t\t\t\t\t\t<upr-gds-name-field\r\n\t\t\t\t\t\t\t*ngSwitchCase=\"'suffix'\"\r\n\t\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t>\r\n\t\t\t\t\t\t</upr-gds-name-field>\r\n\r\n\t\t\t\t\t\t<!-- Phone Number -->\r\n\t\t\t\t\t\t<upr-gds-phone-field\r\n\t\t\t\t\t\t\t*ngSwitchCase=\"'phoneNumber'\"\r\n\t\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t\t[countryName]=\"selectedCountry\"\r\n\t\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t>\r\n\t\t\t\t\t\t</upr-gds-phone-field>\r\n\r\n\t\t\t\t\t\t<!-- Email -->\r\n\t\t\t\t\t\t<upr-gds-email-field\r\n\t\t\t\t\t\t\t*ngSwitchCase=\"'email'\"\r\n\t\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t></upr-gds-email-field>\r\n\r\n\t\t\t\t\t\t<!-- Date of Birth -->\r\n\t\t\t\t\t\t<upr-gds-dob-field\r\n\t\t\t\t\t\t\t*ngSwitchCase=\"'dateOfBirth'\"\r\n\t\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t></upr-gds-dob-field>\r\n\r\n\t\t\t\t\t\t<!-- Country -->\r\n\t\t\t\t\t\t<upr-gds-address-field\r\n\t\t\t\t\t\t\t*ngSwitchCase=\"'country'\"\r\n\t\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t\t(countryChange)=\"onCountryChange($event, formElement.data.action)\"\r\n\t\t\t\t\t\t\t[country]=\"selectedCountry\"\r\n\t\t\t\t\t\t\t[state]=\"selectedState\"\r\n\t\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t\t[isZipCodeMandiory]=\"isZipCodeManditory\"\r\n\t\t\t\t\t\t\t[useNativeStateDropdown]=\"true\"\r\n\t\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t>\r\n\t\t\t\t\t\t</upr-gds-address-field>\r\n\r\n\t\t\t\t\t\t<div\r\n\t\t\t\t\t\t\t*ngSwitchCase=\"'country'\"\r\n\t\t\t\t\t\t\trole=\"region\"\r\n\t\t\t\t\t\t\taria-live=\"polite\"\r\n\t\t\t\t\t\t\tclass=\"sr-only\"\r\n\t\t\t\t\t\t\t[innerHTML]=\"countryLabel\"\r\n\t\t\t\t\t\t></div>\r\n\r\n\t\t\t\t\t\t<!-- State -->\r\n\t\t\t\t\t\t<ng-container *ngSwitchCase=\"'state'\">\r\n\t\t\t\t\t\t\t<upr-gds-address-field\r\n\t\t\t\t\t\t\t\t*ngIf=\"isUsCountry\"\r\n\t\t\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t\t\t[country]=\"selectedCountry\"\r\n\t\t\t\t\t\t\t\t[state]=\"selectedState\"\r\n\t\t\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t\t\t[isZipCodeMandiory]=\"isZipCodeManditory\"\r\n\t\t\t\t\t\t\t\t[useNativeStateDropdown]=\"true\"\r\n\t\t\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t</upr-gds-address-field>\r\n\t\t\t\t\t\t\t<gds-spacer classes=\"spacer-50\" *ngIf=\"isUsCountry\"></gds-spacer>\r\n\t\t\t\t\t\t</ng-container>\r\n\r\n\t\t\t\t\t\t<!-- Zip -->\r\n\t\t\t\t\t\t<ng-container *ngSwitchCase=\"'zip'\">\r\n\t\t\t\t\t\t\t<upr-gds-address-field\r\n\t\t\t\t\t\t\t\t*ngIf=\"isUsCountry\"\r\n\t\t\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t\t\t[country]=\"selectedCountry\"\r\n\t\t\t\t\t\t\t\t[state]=\"selectedState\"\r\n\t\t\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t\t\t[isZipCodeMandiory]=\"formElement.required\"\r\n\t\t\t\t\t\t\t\t[useNativeStateDropdown]=\"true\"\r\n\t\t\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t</upr-gds-address-field>\r\n\t\t\t\t\t\t\t<gds-spacer classes=\"spacer-50\" *ngIf=\"isUsCountry\"></gds-spacer>\r\n\t\t\t\t\t\t</ng-container>\r\n\r\n\t\t\t\t\t\t<!-- Button -->\r\n\t\t\t\t\t\t<gds-buttons\r\n\t\t\t\t\t\t\t*ngSwitchCase=\"'button'\"\r\n\t\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t\t[data]=\"formElement.data\"\r\n\t\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t\t(buttonClicked)=\"gdsButtonClicked(formElement.data.action)\"\r\n\t\t\t\t\t\t></gds-buttons>\r\n\r\n\t\t\t\t\t\t<!-- Spacer -->\r\n\t\t\t\t\t\t<gds-spacer\r\n\t\t\t\t\t\t\tclasses=\"spacer-50\"\r\n\t\t\t\t\t\t\t*ngIf=\"formElement.type !== 'state' && formElement.type !== 'zip'\"\r\n\t\t\t\t\t\t></gds-spacer>\r\n\t\t\t\t\t</ng-container>\r\n\t\t\t\t</ng-container>\r\n\t\t\t</ng-container>\r\n\t\t</div>\r\n\t</div>\r\n</ng-container>\r\n",
      styles: [".sr-only{position:absolute;width:1px;height:1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;clip-path:inset(50%);border:0}\n"]
    }]
  }], () => [{
    type: i1$1.FormBuilder
  }, {
    type: Document,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i2$1.FormControlService
  }, {
    type: GdsInputFormService
  }, {
    type: i4$1.PageLabelsResolver
  }], null);
})();
class GdsInputFormModule {
  static {
    this.ɵfac = function GdsInputFormModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsInputFormModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GdsInputFormModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [GdsInputFormService],
      imports: [CommonModule, FormFieldsModule, FormsModule, ReactiveFormsModule, FtcModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsInputFormModule, [{
    type: NgModule,
    args: [{
      providers: [GdsInputFormService],
      declarations: [GdsInputFormComponent, GdsInputFormCvaDirective],
      imports: [CommonModule, FormFieldsModule, FormsModule, ReactiveFormsModule, FtcModule],
      exports: [GdsInputFormComponent],
      schemas: [CUSTOM_ELEMENTS_SCHEMA]
    }]
  }], null, null);
})();

/*
 * Public API Surface of gds-input-form
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GdsInputFormComponent, GdsInputFormModule, GdsInputFormService };
